import React from 'react'
function TR(props) {
    return(
        <tr>
            {props.children}
        </tr>
    )
}
export default TR;
